module.exports = __webpack_public_path__ + "static/media/seriousPersistentPain.56b539a0.mp3";